import { ButtonWithIcon } from '@oy/uidesktop';
import { useDispatch } from 'react-redux';
import {
  B2xPermissionDetail,
  B2xPermissionProducts,
  BusinessTypeValue,
} from 'src/constants';
import {
  useBusinessTypeData,
  useEnv,
  usePermission,
  useProductActive,
  useTranslate,
} from 'src/hooks';
import { useUserManagementList } from 'src/pages/Accounts/UserManagement/hooks';
import { USER_MANAGEMENT_ACTION_TYPES } from 'src/pages/Accounts/UserManagement/redux';

export function UserManagementActionButton() {
  const { data: businessData } = useBusinessTypeData();
  const { hasPermission } = usePermission();
  const dispatch = useDispatch();
  const { getTranslation } = useTranslate();
  const { isSubAccountActive } = useProductActive();
  const { isProdEnv } = useEnv();
  const { data } = useUserManagementList();
  const subAccounts = data.filter(account => account.username.includes('~'));

  const showCreateSubAccountButton = hasPermission(
    B2xPermissionProducts.USER_MANAGEMENT,
    B2xPermissionDetail.EDITOR,
  );

  const onClick = () => {
    if (isProdEnv) {
      if (businessData.business_type !== BusinessTypeValue.Corporate) {
        if (!isSubAccountActive || subAccounts.length >= 1) {
          dispatch({
            type: USER_MANAGEMENT_ACTION_TYPES.SET_WARNING_INDIVIDUAL,
            payload: true,
          });
          return;
        }
      }
    }
    dispatch({
      type: USER_MANAGEMENT_ACTION_TYPES.SET_SIDE_MODAL,
      payload: true,
    });
  };

  if (!showCreateSubAccountButton) return null;
  return (
    <ButtonWithIcon
      id="btnAddUser"
      iconName="add"
      size={ButtonWithIcon.Size.Small}
      onClick={onClick}
    >
      {getTranslation('pageTitle_createUserProfile')}
    </ButtonWithIcon>
  );
}
